<div class="container">
  <div class="row align-items-center">
    <div class="col link-card bg-white">
      <div class="row">
        <a class="col-2 d-flex flex-middle flex-center" data-test="dms-file-link-card-link">
          <i class="icon-iris dms-icon-color fa-3x" [ngClass]="fileIcon()"></i>
        </a>
        <div class="col-8">
          <div class="row">
            <div class="col">
              @if (!hasFolderReadPermission()) {
                <span class="at-file-name text-break">{{ linkedFileName() }}</span>
              } @else {
                <a [href]="fileSourceUrl()"
                  target="_blank"
                  [matTooltip]="'label.dms.OpenPreview' | translate"
                  class="at-file-name text-break"
                  data-test="dms-file-link-card-open-preview-link">
                  {{ linkedFileName() }}
                  <i class="fas fa-external-link-alt fa-fw"></i>
                </a>
              }
            </div>
          </div>
          <div class="row pt-1">
            <div class="col">
              @if (!hasFolderReadPermission()) {
                <span class="at-file-name text-break">{{ linkedFilePath() }}</span>
              } @else {
                <a [href]="folderSourceUrl()"
                  target="_blank"
                  [matTooltip]="'label.dms.GoToFolder' | translate"
                  class="at-file-path text-break"
                  data-test="dms-file-link-card-go-to-folder-link">
                  <i class="grey fas fa-folder-open fa-fw"></i>
                  {{ linkedFilePath() }}
                </a>
              }
            </div>
          </div>
        </div>
        @if (showDownloadButton()) {
          <div class="col-2">
            <iris-dms-download-file-button [file]="linkedFile()" data-test="dms-file-link-card-button">
            </iris-dms-download-file-button>
          </div>
        }
      </div>
    </div>
    @if (showUnlinkButton()) {
      <div class="col-2">
        <iris-dms-unlink-file-to-file-button
          [fileId]="fileId()"
          [linkedFileId]="linkedFileId()"
          data-test="dms-file-link-card-button-2"
        >
        </iris-dms-unlink-file-to-file-button>
      </div>
    }
  </div>
</div>
